import { Component } from '@angular/core';

@Component({
    selector: 'kh-webgl-unsupported',
    styleUrls: ['./webgl-unsupported.component.less'],
    templateUrl: './webgl-unsupported.component.html',
    standalone: false
})
export class WebglUnsupportedComponent {}
